import styled from "styled-components";


export const TitleBar = styled.div.attrs({
  className: "text-center text-medium font-semibold py-3 w-full px-4",
})`
  background-color: var(--primaryPurpleMain);
  color: #fbf8fc;
`;